import React, { Component } from "react";
import styles from "./MainHead.module.css";
import DashedBtn from "../../../components/Button/DashedBtn";

function MainHead() {
  return (
    <>
      <div className={`${styles.HeaderElement}`}>
        <span>شرکت فنی مهندسی</span>
        <h1>نیکان</h1>
        <div className={`${styles.HeaderDisc} `}>
          <p>
            شرکت نیکان ، تولید کننده نرم افزار های تخصصی ردیابی خودرو و مدیریت
            ناوگان ، با قابلیت سفارشی سازی برای مشتری...{" "}
          </p>
        </div>
        <DashedBtn
          className={`${styles.raahyabBtn}`}
          link={"http://www.raahyab.com/login"}
          target="_blanck">
          RAAHYAB
        </DashedBtn>
      </div>
    </>
  );
}

export default MainHead;
